<template>
  <!-- list-type:text 文件上传格式 -->
  <div class="textType-box">
    <ul class="filelist-ul" v-show="fileList.length">
      <li class="items" v-for="(file, index) in fileList" :key="file.uid">
        <div class="_info">
          <div class="_info__name">
            <div class="_info__icon"></div>
            <span class="txt" :title="file.name">{{ file.name }}</span>
          </div>
          <div class="_info__operate">
            <div class="_info__succeed" v-if="file.status === 'success'"></div>
            <i
              v-if="file.status === 'success'&& viewShow(file)"
              @click.stop="imgViewClick(file)"
              class="QS-icon-view"></i>
            <i
              v-if="file.status === 'success'"
              @click.stop="deleteUploadHandle(index)"
              class="el-icon-delete"
              ></i>
          </div>
        </div>
        <div v-if="file.status === 'ready' || file.status === 'uploading'">
          <div class="progress-item">
            <el-progress
              :show-text="false"
              :stroke-width="2"
              :percentage="file.percentage || uploadPercent"
            ></el-progress>
          </div>
        </div>
      </li>
    </ul>
    <ImageView :imgViewShow="imgViewShow" :imgList="imgViewList" @closeImgView="closeImgView" v-if="imgViewShow"/>
  </div>
</template>

<script>
import ImageView from './ImageView.vue'
// import PdfView from './PdfView.vue'
export default {
  name: 'TextTypeBox',
  components: {
    ImageView,
    // PdfView
  },
  data() {
    return {
      imgViewShow: false, // 图片预览,
      imgViewList: [], // 预览图片文件列表
      acceptImageType: ['.png', '.jpg', '.jpeg', '.webp', '.bmp', '.svg'],
    }
  },
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    uploadPercent: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    deleteUploadHandle(index) {
      this.$emit('deleteUploadHandle', index)
    },
    // 关闭图片预览
    closeImgView() {
      this.imgViewShow = false
      this.imgViewList = []
    },
    // 点击预览
    imgViewClick(file) {
      const type = this.getFileType(file.name)
      if (this.acceptImageType.includes(type.toLowerCase())) {
        this.imgViewShow = true
        // 创建新的数组而不是直接修改原数组，避免无限更新循环
        this.imgViewList = [file.url]
      }
    },
    // 获取文件类型
    getFileType(file) {
      if (file) {
        return file.slice(file.lastIndexOf('.'))
      } else {
        return ''
      }
    },
    // 图片预览显示
    viewShow(file) {
      const type = this.getFileType(file.name)
      if (this.acceptImageType.includes(type.toLowerCase())) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
::v-deep ._info {
  display: flex;
  padding-right: 0;
  &__icon {
    width: 16px;
    height: 16px;
    background-image: url('../assets/QS-ic-sc-excel@2x.png');
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 4px;
  }
  &__succeed {
    width: 16px;
    height: 16px;
    background-image: url('../assets/QS-ic-succeed@2x.png');
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 8px;
  }
  &__name {
    display: flex;
    align-items: center;
    flex: 1;
  }
  &__operate {
    width: 64px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .QS-icon-view {
    font-size: 16px;
    margin-right: 8px;
    cursor: pointer;
  }
  .el-icon-delete {
    font-size: 16px;
    color: #323233;
    cursor: pointer;
  }
}
</style>
